import React from "react";
import { HisDoctor } from "../api/models";
import { Identifier } from "./Identifier";

interface DoctorOptimedLabelProps {
  doctor: HisDoctor | undefined;
  hideId?: boolean;
}

export function DoctorOptimedLabel(props: DoctorOptimedLabelProps) {
  const { doctor } = props;
  if (!doctor) return null;

  const hasFirstOrLastName = !!(doctor.imie || doctor.nazwisko);

  return (
    <span>
      <span hidden={!hasFirstOrLastName}>
        {doctor.imie} {doctor.nazwisko}
      </span>
      <span hidden={hasFirstOrLastName}>{doctor.nazwa}</span>{" "}
      {!props.hideId && <Identifier value={doctor.id} title="Optimed NXT" />}
    </span>
  );
}
